const CONTENT = {
  SUBSCRIBE: {
    headline: `Good ideas?\nWe’ve got a few.`,
    subhead: "",
    body:
      "Sign up for our emails to be the first to find out about our latest breakthroughs and news.",
    thanks: "Thank you! Please check your inbox!",
    error: "There was a problem with your submission. We apologize -- please try again later."
  },
  CONTACT: {
    ERROR: "We apologize -- there was a problem with the form submission. Please try again later.",
    CAPTED: "User check failed on form. Please try again later."
  },
  RESOURCES: {
    title: ""
  },
  NEWSROOM: {
    title: "The Latest News and Events"
  },
  GET_IN_TOUCH: {
    DEFAULT: {
      defHeadline: `Let’s get in touch`,
      defSubhead: `For more info or a demo request, just drop us a message.`,
      defCtaCopy: `Contact Us`
    },
    CONTACT: {
      headline: "Need help now?",
      subhead: "Find answers to frequently asked questions.",
      ctaCopy: "View FAQ"
    }
  },
  OUR_PEOPLE: {
    FEATURED: "Meet the\nUnreasonable Team"
  },
  BIO: {
    BACK_LINK: "Back",
    BACK_LINK_TARGET: "our-people-team"
  },
  CAREERS: {
    JOINUS: {
      cta: "Find Your Role",
      headline1: "Join Us",
      headline2:
        "If this sounds like you, go ahead and introduce yourself. We look forward to meeting you."
    },
    HEADER: {
      eyebrow: "Careers",
      cta: "Find Exo's Open Roles"
    }
  },
  FOUROHFOUR: {
    eyebrow: "Error 404",
    headline: "Page not\nfound",
    subhead:
      "The page you were looking for doesn’t exist. You may have mistyped the address or the page may have moved.",
    ctaLabel: "Back Home"
  },
  SUPPORT: {
    eyebrow: "Customer Support",
    headline: "Need a hand?",
    subhead: ""
  },
  EXO_DEMO_FORM: {
    title: "Book a Demo",
    lead: "",
    header: "Contact",
    completeContent: {
      eyebrow: "Form Submitted",
      header: "We'll be in touch.",
      body: "The Exo Works team will respond within two business days."
    }
  }
}

export default CONTENT
